import styled from 'styled-components';


export const Container = styled.header`
	margin-block: 48px;

	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
`;
